export const HEADER_FOOTER_QUERY = `
  header: menus(filters: { title: { eq: "Header"} }, locale: "*") {
    documentId
    title
    locale
    items {
      label
      url
    }
  }
  technologies: menus(filters: { title: { eq: "Main Technologies"} }, locale: "en") {
    documentId
    title
    locale
    items {
      label
      url
    }
  }
  footerPt: menus(locale: "pt") {
    documentId
    title
    locale
    items {
      label
      url
    }
  }
  footerEn: menus(locale: "en") {
    documentId
    title
    locale
    items {
      label
      url
    }
  }
  services: menus(filters: { title: {eq: "Services"} }, locale: "en") {
    documentId
    title
    locale
    items {
      label
      url
    }
  }
`;
